import { IconBrushMagic } from '@picsart/design-system/foundation/icons/IconBrushMagic';
import { useTranslator } from '@picsart/rc/services/localization';
import useStyles from './styles';

const CreateSkeleton = () => {
  const classes = useStyles();
  const translate = useTranslator();
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <IconBrushMagic fill="currentColor" className={classes.headerIcon} />
        {translate('Create')}
      </div>
      <div className={classes.content}>
        <div className={`${classes.skeleton} ${classes.skeletonPreview}`} />
        <div className={`${classes.skeleton} ${classes.skeletonDescription}`} />
        <div className={classes.uploadSection}>
          <div className={`${classes.skeleton} ${classes.skeletonInput}`} />
        </div>
      </div>
      <div className={classes.footer} style={{ animation: 'none' }}>
        <div className={`${classes.skeleton} ${classes.skeletonButton}`} />
      </div>
    </div>
  );
};

export default CreateSkeleton;
